import React, { useState, useEffect } from "react";
import "./ProfileSettings.css";  
import Service from "../../../API/Service";
import { useNavigate } from "react-router-dom";

const ConfirmationEmail = ({ newPassword }) => {
    const navigate = useNavigate();
    const [code, setCode] = useState(["", "", "", "", "", ""]);
    const [timeLeft, setTimeLeft] = useState(59);
    const [resendText, setResendText] = useState("Receive code again in 00:59");
    const [isError, setIsError] = useState(false);
    const [resendDisabled, setResendDisabled] = useState(true);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setTimeout(() => {
                setTimeLeft(timeLeft - 1);
                setResendText(`Receive code again in 00:${timeLeft - 1 < 10 ? `0${timeLeft - 1}` : timeLeft - 1}`);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setResendText("Send");
            setResendDisabled(false);
        }
    }, [timeLeft]);

    const handleInputChange = (index, value) => {
        if (/^\d?$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);

            setIsError(false);


            if (value && index < 5) {
                document.getElementById(`code-input-${index + 1}`).focus();
            }
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !code[index] && index > 0) {
            document.getElementById(`code-input-${index - 1}`).focus();
        }
    };

    const handleConfirm = async () => {
        if (code.includes("") || code.length < 6) {
            alert("Please enter the full confirmation code.");
            return;
        }

        try {
            const personalData = await Service.getPersonalData();
            const otpCode = code.join("");

            await Service.checkOtp(personalData.login, otpCode); 
            await Service.changePassword(personalData.login, newPassword); 
            console.log("Navigating to /profile");
            navigate("/profile", { state: { activeTab: "profile", successMessage: "You successfully changed your password" }, replace: true });
            setIsError(false);
        } catch (error) {
            console.error("Ошибка подтверждения OTP:", error);
            if (error.response?.status === 500) {
                setIsError(true);
            }
        }
    };

    const handleResendOtp = async () => {
        try {
            setResendDisabled(true);
            setTimeLeft(59);
            setResendText("Receive code again in 00:59");

            const personalData = await Service.getPersonalData();
            await Service.sendOtp(personalData.login);
        } catch (error) {
            console.error("Ошибка повторной отправки OTP:", error);
        }
    };

    return (
        <div className="confirmationContainer">

            <div className="confirmationContent">
                <h2 className="confirmationTitle">We have sent a one-time <br/> password to your email</h2>
                <p className="confirmationText">Enter the confirmation code from the email below</p>
            </div>

            <div className="codeBlock">
                <div className="codeInputContainer">
                    {code.map((digit, index) => (
                        <input
                            key={index}
                            id={`code-input-${index}`}
                            placeholder="0"
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleInputChange(index, e.target.value)}
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            className={`codeInput ${isError ? "error" : ""}`}
                        />
                    ))}
                </div>

                <button 
                    className="resendButton" 
                    disabled={resendDisabled} 
                    onClick={handleResendOtp}
                >
                    {resendText}
                </button>

                <button className="confirmButton" onClick={handleConfirm}>
                    Confirm
                </button>
            </div>
        </div>
    );
};

export default ConfirmationEmail;
